<template>
<div id="bundle-analysis">
    <c-body :wrap="false">
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
					<Input v-model="tableParams.keyword" 
						   placeholder="请输入包名"
						   class="header-search"
						   icon="android-search"
						   @on-keydown.enter="getList(true)"
						   @on-click="getList(true)" />
					<Button @click="onClickDown" type="primary">下载</Button>
                </div>
                <div class="header-row-right">
					<!-- 预设日期按钮 -->
					<c-date-picker :startDay.sync="tableParams.startDay" 
                                   :endDay.sync="tableParams.endDay"
                                   :defaultDate="defaultDate"
                                   @change="getList" />
				</div>
            </div>
        </header>

		<!-- 主体section模块 -->
		<section slot="section" class="c-body-section" style="overflow-x:auto">
			<!-- 表格 -->
			<table class="c-body-table">
				<!-- 表格标题 -->
				<thead class="table-thead">
					<tr class="table-tr">
						<td v-for="item in tableList"
							:key="item.title"
							class="table-td-primary table-sort"
                            style="min-width:140px"
							:class="{'active':tableParams.orderName==item.value,'table-td-long':item.title=='包名'}"
							:style="{cursor:item.value?'pointer':''}"
							@click="sortTable(item.value)">
							<span>{{item.title}}</span>
							<Icon v-if="tableParams.orderName==item.value" 
								  :class="{'table-sort-icon':tableParams.orderType=='asc'}"
								  type="arrow-down-b" />
						</td>
					</tr>
				</thead>

                <tbody class="table-tbody">
                    <tr class="table-tr" v-for="item in originData" :key="item.code">
                        <td class="table-td-long"><p class="showregular" :title="item.name">{{item.name}}</p></td>
                        <td class="table-td-primary">{{item.bid}}</td>
                        <td class="table-td-primary">{{item.imp}}</td>
                        <td class="table-td-primary">{{item.click}}</td>
                        <td class="table-td-primary">{{item.ctr}}</td>
                        <td class="table-td-primary">{{item.cpa}}</td>
                        <td class="table-td-primary">{{item.cpc}}</td>
                        <td class="table-td-primary">{{item.cpm}}</td>
                        <td class="table-td-primary">{{item.calculateImp}}</td>
                        <td class="table-td-primary">{{item.calculateClick}}</td>
                        <td class="table-td-primary">{{item.calculateSpends}}</td>
                        <td class="table-td-primary">{{item.calculateCpc}}</td>
                        <td class="table-td-primary">{{item.calculateCpm}}</td>
                        <td class="table-td-primary">{{item.install}}</td>
                        <td class="table-td-primary">{{item.installRate}}</td>
                        <td class="table-td-primary">{{item.deal}}</td>
                        <td class="table-td-primary">{{item.dealRate}}</td>
                        <td class="table-td-primary">{{item.ecpm}}</td>
                        <td class="table-td-primary">{{item.amount}}</td>
                        <td class="table-td-primary">{{item.payPrice}}</td>
                    </tr>
                </tbody>
			</table>
		</section>
        <footer slot="footer" class="c-body-footer">
            <!-- 分页器 -->
            <c-page :table-params.sync="tableParams" 
                    :page-bean.sync="pageBean"
                    class="foot-row"
                    @on-change="getList(false)"
                    @on-page-size-change="getList(true)" />
        </footer>
    </c-body>
</div>
</template>
<script>
import cBody from '@/components/commons/cBody.vue';
import cPage from '@/components/commons/cPage.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import mixins from '@/mixins/index.js';
export default {
    name: 'BundleAnalysis',
    mixins: [mixins],
    components: {
        cBody,
        cPage,
        cDatePicker
    },
    data() {
        return {
            //表头
            tableList: [
                { title: '包名', value: 'name' },
                { title: '竞价请求量', value: 'bid' },
                { title: '展现量', value: 'imp' },
                { title: '点击量', value: 'click' },
                { title: 'CTR', value: 'ctr' },
                { title: 'CPA', value: 'cpa' },
                { title: 'CPC', value: 'cpc' },
                { title: 'CPM', value: 'cpm' },
                { title: '补/扣量后的clickimp数', value: 'calculateImp' },
                { title: '补/扣量后的click数', value: 'calculateClick' },
                { title: '补/扣量后的花费数', value: 'calculateSpends' },
                { title: '补/扣量后的cpc', value: 'calculateCpc' },
                { title: '补/扣量后的cpm', value: 'calculateCpm' },
                { title: '安装量', value: 'install' },
                { title: '安装率', value: 'installRate' },
                { title: '转化量', value: 'deal' },
                { title: '转化率', value: 'dealRate' },
                { title: 'eCPM', value: 'ecpm' },
                { title: '收益', value: 'amount' },
                { title: '支出', value: 'payPrice' }
            ],
            originData: [],
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 0
            },
            //获取列表参数
            tableParams: {
                keyword: '',
                page: 1,
                pageSize: 10,
                dimension: 'bundle',
                startDay: this.mixinGetDate('today'),
                endDay: this.mixinGetDate('today'),
                orderName: 'code',
                orderType: 'desc',
                categoryCode: ''
            },
            //预设日期按钮
            defaultDate: [
                {
                    type: '今天',
                    startDay: this.mixinGetDate('today'),
                    endDay: this.mixinGetDate('today'),
                },
                {
                    type: '昨天',
                    startDay: this.mixinGetDate('yesterday'),
                    endDay: this.mixinGetDate('yesterday')
                },
                {
                    type: '近一周',
                    startDay: this.mixinGetDate('week'),
                    endDay: this.mixinGetDate('yesterday')
                }
            ]
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        /*
		 * @description 获取列表
		 * @param isInit:boolean 是否初始化
		 */
        async getList(isInit = false) {
            if (isInit) this.tableParams.page = 1;
            const res = await this.$axios.get(this.$port.globalReport.list, { params: this.tableParams });
            this.originData = res.data.list;
            this.pageBean = res.data.pageBean;
        },
        /*
         * @description 报表下载
         */
        onClickDown() {
            const params = Object.assign({}, this.tableParams);
            params.rd = new Date().getTime();
            let queryString = `${this.$port.globalReport.download}?`;
            for (let i in params) {
                queryString += `${i}=${params[i]}&`;
            }
            window.location.href = queryString;
        },
        /*
		 * @description 表格排序
		 * @param value:string 排序的索引
		 */
        sortTable(value) {
            // 无效排序返回
            if (!value) return;
            if (value == this.tableParams.orderName) {
                this.tableParams.orderType = this.tableParams.orderType == 'asc' ? 'desc' : 'asc';
            } else {
                this.tableParams.orderName = value;
                this.tableParams.orderType = 'desc';
            }
            this.getList(true);
        }
    }
};
</script>
<style lang="scss">
</style>





// WEBPACK FOOTER //
// src/view/DataAnalysis/BundleAnalysis.vue